export enum SORT_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
}

export enum PRODUCT_CATEGORY_LIST_COLUMN {
  NAME = 'name',
  PRODUCTS_COUNT = 'products_count',
  ACTIONS = 'actions',
}

export interface ProductCategorySubMenuProps {
  anchorEl: HTMLElement | null;
  onCloseMenu: () => void;
  selectedCategoryId: number | null;
}

export interface Column {
  label: string;
  key: PRODUCT_CATEGORY_LIST_COLUMN;
  sortIcon: boolean;
}
